import React from "react";
import { Link, usePage } from "@inertiajs/react";
import { Menu, Search, User, LogOut, ChevronDown } from "lucide-react";

const PAGE_LABELS = [
    ["/dashboard/crm/conversations", "المحادثات"],
    ["/dashboard/crm/campaigns", "الحملات البريدية"],
    ["/dashboard/crm/companies", "الشركات"],
    ["/dashboard/crm/contacts", "جهات الاتصال"],
    ["/dashboard/crm/deals", "الصفقات"],
    ["/dashboard/crm/tasks", "المهام"],
    ["/dashboard/crm", "إدارة العملاء"],
    ["/dashboard/blogs/create", "مقال جديد"],
    ["/dashboard/blogs", "المدونات"],
    ["/dashboard/seo", "إدارة السيو"],
    ["/dashboard/projects", "المشاريع"],
    ["/dashboard/contacts", "استفسارات العملاء"],
    ["/dashboard/profile", "الملف الشخصي"],
    ["/dashboard", "لوحة التحكم"],
];

const Header = ({ toggleSidebar }) => {
    const page = usePage();
    const auth = page.props.auth || {};
    const url = page.url || "/dashboard";
    const pageLabel = PAGE_LABELS.find(([path]) => url.startsWith(path))?.[1] || "لوحة الإدارة";

    const openSearch = () => {
        window.dispatchEvent(new CustomEvent("open-command-palette"));
    };

    return (
        <header className="sticky top-0 z-30 border-b border-gray-200/80 bg-white/95 backdrop-blur">
            <div className="mx-auto flex h-[72px] w-full max-w-[1800px] items-center justify-between gap-4 px-4 sm:px-5 lg:px-8">
                <div className="flex min-w-0 items-center gap-3">
                    <button
                        type="button"
                        onClick={toggleSidebar}
                        aria-label="فتح القائمة الجانبية"
                        className="rounded-xl border border-gray-200 p-2 text-gray-600 transition hover:bg-gray-50 lg:hidden"
                    >
                        <Menu className="h-5 w-5" />
                    </button>
                    <div className="min-w-0">
                        <p className="truncate text-sm font-bold text-gray-900 sm:text-base">{pageLabel}</p>
                        <p className="hidden text-xs text-gray-500 sm:block">مساحة العمل الإدارية</p>
                    </div>
                </div>

                <div className="flex items-center gap-2 sm:gap-3">
                    <button
                        type="button"
                        onClick={openSearch}
                        aria-label="فتح البحث السريع"
                        className="flex h-10 items-center gap-2 rounded-xl border border-gray-200 bg-gray-50 px-3 text-sm text-gray-500 transition hover:border-primary-200 hover:bg-primary-50 hover:text-primary-700 sm:min-w-52"
                    >
                        <Search className="h-4 w-4 shrink-0" />
                        <span className="hidden sm:inline">بحث سريع...</span>
                        <kbd className="mr-auto hidden rounded-md border border-gray-200 bg-white px-1.5 py-0.5 text-[10px] text-gray-400 sm:inline">⌘ K</kbd>
                    </button>

                    <div className="group relative">
                        <button
                            type="button"
                            aria-label="قائمة المستخدم"
                            className="flex items-center gap-2 rounded-xl border border-gray-200 bg-white p-1.5 pl-2 transition hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500/20"
                        >
                            <span className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-lg bg-primary-100 text-primary-700">
                                {auth.avatar
                                    ? <img className="h-full w-full object-cover" src={"/storage/" + auth.avatar} alt="" />
                                    : <User className="h-4 w-4" />}
                            </span>
                            <span className="hidden max-w-32 truncate text-sm font-semibold text-gray-700 sm:block">{auth.name || "المستخدم"}</span>
                            <ChevronDown className="hidden h-4 w-4 text-gray-400 sm:block" />
                        </button>

                        <div className="invisible absolute left-0 top-full z-50 mt-2 w-48 translate-y-1 rounded-xl border border-gray-200 bg-white p-1.5 opacity-0 shadow-lg transition group-hover:visible group-hover:translate-y-0 group-hover:opacity-100 group-focus-within:visible group-focus-within:translate-y-0 group-focus-within:opacity-100">
                            <Link
                                href="/dashboard/profile"
                                className="flex items-center gap-2 rounded-lg px-3 py-2.5 text-sm text-gray-700 transition hover:bg-gray-50"
                            >
                                <User className="h-4 w-4 text-gray-500" />
                                الملف الشخصي
                            </Link>
                            <Link
                                href="/logout"
                                method="post"
                                as="button"
                                className="flex w-full items-center gap-2 rounded-lg px-3 py-2.5 text-right text-sm text-red-600 transition hover:bg-red-50"
                            >
                                <LogOut className="h-4 w-4" />
                                تسجيل الخروج
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
